const PERMISSIONS = {
  USER: {
    CREATE: 'user.create',
    UPDATE: 'user.update',
    DELETE: 'user.delete',
    GET: 'user.get',
    LIST: 'user.list',
  },
  BRAND_CURATION_TASK: {
    LIST: 'brandCurationTask.list',
    GET: 'brandCurationTask.get',
    UPDATE: 'brandCurationTask.update',
    REOPEN: 'brandCurationTask.reopen',
    DELETE: 'brandCurationTask.delete',
    ASSIGN_USER: 'brandCurationTask.assignUser',
    ASSIGN_USERS: 'brandCurationTask.assignUsers',
    DUPLICATE: 'brandCurationTask.duplicate',
    UPDATE_STATUS_FLAGS: 'brandCurationTask.updateStatusFlags',
    UPDATE_TAGS: 'brandCurationTask.updateTags',
  },
  MENU: {
    GET_DATA: 'menu.getData',
  },
  LOCATION: {
    LIST: 'location.list',
    UPDATE: 'location.update',
    UPDATE_STATUS_FLAGS: 'location.updateStatusFlags',
  },
  MENU_CURATION_TASK: {
    LIST: 'menuCurationTask.list',
    GET: 'menuCurationTask.get',
    UPDATE: 'menuCurationTask.update',
    REOPEN: 'menuCurationTask.reopen',
    DELETE: 'menuCurationTask.delete',
    RETRY_CURATION: 'menuCurationTask.retryCuration',
    ASSIGN_USER: 'menuCurationTask.assignUser',
    ASSIGN_USERS: 'menuCurationTask.assignUsers',
    DUPLICATE: 'menuCurationTask.duplicate',
    UPDATE_STATUS_FLAGS: 'menuCurationTask.updateStatusFlags',
    UPDATE_MENU_TITLE: 'menuCurationTask.updateMenuTitle',
    SET_MENU_TITLE_IGNORED: 'menuCurationTask.setMenuTitleIgnored',
    UPDATE_DETAIL_LEVEL: 'menuCurationTask.updateDetailLevel',
    UPDATE_TAGS: 'menuCurationTask.updateTags',
    VIEW_BACKLOG_FILTER: 'menuCurationTask.viewBacklogFilter',
    VIEW_ASSIGN_FILTERS: 'menuCurationTask.viewAssignFilters',
    UPDATE_SCRAPING_REVIEW_STATUS:
      'menuCurationTask.updateScrapingReviewStatus',
    REQUEST_SCRAPING_REVIEW: 'menuCurationTask.requestScrapingReview',
    UNLOCK_DISHES: 'menuCurationTask.unlockDishes',
    START_TARGETED_DB_FLASH: 'menuCurationTask.startTargetedDbFlash',
  },
  UNKNOWN_WORD: {
    UPDATE: 'unknownWord.update',
    DELETE: 'unknownWord.delete',
    LIST: 'unknownWord.list',
  },
  DISH: {
    CREATE: 'dish.create',
    UPDATE: 'dish.update',
    PUBLISH: 'dish.publish',
    GET: 'dish.get',
    LIST: 'dish.list',
    UPDATE_STATUS_FLAGS: 'location.updateStatusFlags',
  },
  SOP: {
    LIST: 'sop.list',
    DELETE: 'sop.delete',
    CREATE: 'sop.create',
  },
  PRIORITY_TASK: {
    LIST: 'priorityTask.list',
    GET: 'priorityTask.get',
    UPDATE: 'priorityTask.update',
    DELETE: 'priorityTask.delete',
    CREATE: 'priorityTask.create',
  },
}

export default PERMISSIONS
